import { Logger, Section } from '@wolfdanepug/common-react'
import { Stack, Typography } from '@mui/material'
import { capitalize, omit } from 'lodash'
import { useEffect, useMemo } from 'react'
import { useQuery } from '../lib/useQuery'
import { GetUnstableData } from '../graphql/docs'
import ActiveSegment from '../components/ActiveSegment'
import PlanBuilder from '../components/PlanBuilder'

export default function PlanBuild() {
	const { data } = useQuery(GetUnstableData, { context: 'onboarding' })

	useEffect(() => {
		Logger.log('[Page] PlanBuild', data)
	}, [data])

	const { petName, profile, discountConfiguration }: any = useMemo(() => {
		const obdata = data?.data
		if (obdata) {
			const dataKey = obdata?.dogs?.[obdata.activeDogContext]
			const dogData = obdata?.dog[dataKey]
			return {
				profile: omit(dogData, 'key'),
				petName: capitalize(dogData?.name),
				discountConfiguration: obdata?.discountConfiguration || null
			}
		}
		return {
			profile: undefined,
			key: undefined,
			discountConfiguration: null
		}
	}, [data])

	return (
		<>
			<ActiveSegment segment="plan-builder" />

			<Stack sx={styles.root}>
				<Section sx={styles.container}>
					<Typography variant="h1">Build {petName}'s Plan</Typography>
					{/* <Typography variant="h4">Choose up to 3 Recipes</Typography> */}
					<Typography variant="body2" sx={styles.body}>
						The recipe(s) we picked are popular for dogs similar to {petName}, but the options below
						are recommended.
					</Typography>
				</Section>
				<Section sx={styles.builder}>
					{profile && <PlanBuilder {...profile} discountConfiguration={discountConfiguration} />}
				</Section>
			</Stack>
		</>
	)
}

const styles = {
	root: {
		display: 'flex',
		flex: 1,
		// width: '100%',
		// height: '100%',
		// pb: '135px',
		pt: 8,
		pb: 8,
		backgroundColor: '#fff2e1'
	},
	container: {
		container: {
			textAlign: 'center'
		},
		content: {
			display: 'flex',
			flexDirection: 'column',
			gap: 3
		}
	},
	content: {
		root: {},
		container: {
			display: 'flex',
			justifyContent: 'center'
		}
	},
	builder: {
		root: {},
		container: {
			display: 'flex',
			justifyContent: 'center'
		},
		content: {
			justifyContent: 'center'
		}
	},
	body: {
		maxWidth: 'sm',
		margin: '0em auto'
	}
}
